module.exports = __webpack_public_path__ + "static/media/edit_btn.d5dff894.svg";